declare global {
  interface Window {
    __INMP_EMBEDDED_PAYLOAD__?: unknown
  }
}

export function getEmbeddedPayload(): unknown | undefined {
  return typeof window !== 'undefined' ? window.__INMP_EMBEDDED_PAYLOAD__ : undefined
}

export function isEmbeddedExport(): boolean {
  return getEmbeddedPayload() !== undefined
}
